import type { ValueMeta } from "@/shared/model";

/**
 * Meta 배열 → id(의미없는 식별자)로 meta 전체 접근하는 맵
 *
 * @example
 * metaToMap(JOB_META) → { 'J01': { id, name, label, value }, ... }
 */
export function metaToMap<M extends ValueMeta<unknown>>(metas: readonly M[]): Record<M["id"], M> {
  return Object.fromEntries(metas.map((m) => [m.id, m])) as Record<M["id"], M>;
}
